export enum FormType {
	InputText = 'InputText',
	InputNumber = 'InputNumber',
	Select = 'Select',
	CheckBox = 'CheckBox',
	DateTime = 'DateTime',
}
